import React from 'react';
import { team } from '../mock';
import useReveal from '../hooks/useReveal';

function TeamCard({ m, i }) {
  const [ref, inView] = useReveal(0.15);
  const rot = i === 1 ? 0 : i === 0 ? -1.5 : 1.5;

  const gradients = [
    'linear-gradient(180deg, var(--teal-light) 0%, var(--teal-2) 100%)',
    'linear-gradient(180deg, var(--orange) 0%, var(--orange-dark) 100%)',
    'linear-gradient(180deg, var(--teal) 0%, var(--teal-dark) 100%)',
  ];

  return (
    <div ref={ref} className={`lift-card reveal delay-${i + 1} ${inView ? 'in-view' : ''}`}
      style={{ position: 'relative', transform: `rotate(${rot}deg)`, transition: 'transform 0.5s cubic-bezier(.2,.8,.2,1)' }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px) rotate(0deg)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = `rotate(${rot}deg)`; }}
    >
      <div className="art-frame">
        <div style={{
          background: gradients[i] || gradients[2],
          height: 260, position: 'relative', overflow: 'hidden',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <span className="font-display" style={{ fontSize: 120, color: 'rgba(255,255,255,0.92)', fontWeight: 700, letterSpacing: '-0.04em' }}>{m.initials}</span>
          <div className="font-mono" style={{ position: 'absolute', top: 14, left: 14, color: 'rgba(255,255,255,0.9)', fontSize: 10, letterSpacing: '0.22em' }}>P.0{i + 1}</div>
          <div className="font-mono" style={{ position: 'absolute', bottom: 14, right: 14, color: 'rgba(255,255,255,0.9)', fontSize: 10, letterSpacing: '0.22em' }}>#{m.tag}</div>
        </div>
      </div>

      <div className="door-plaque" style={{ marginTop: 10, marginLeft: 20, marginRight: 20, padding: '14px 20px', position: 'relative' }}>
        <span className="screw" style={{ top: 6, left: 6 }} />
        <span className="screw" style={{ top: 6, right: 6 }} />
        <span className="screw" style={{ bottom: 6, left: 6 }} />
        <span className="screw" style={{ bottom: 6, right: 6 }} />
        <div className="font-mono" style={{ color: 'var(--ink)', fontSize: 9, letterSpacing: '0.22em', textTransform: 'uppercase', opacity: 0.7 }}>{m.role}</div>
        <div className="font-display" style={{ color: 'var(--ink)', fontSize: 18, marginTop: 4, letterSpacing: '-0.01em' }}>{m.name}</div>
      </div>

      <p style={{ color: 'var(--smoke)', fontSize: 13, lineHeight: 1.6, marginTop: 18, padding: '0 8px' }}>{m.bio}</p>
    </div>
  );
}

export default function Team() {
  const [ref, inView] = useReveal(0.1);
  return (
    <section ref={ref} className="section" style={{ background: 'var(--ink-2)', position: 'relative' }}>
      <div className="container-x">
        <div className="text-center" style={{ marginBottom: 80 }}>
          <div className={`reveal ${inView ? 'in-view' : ''}`}>
            <div className="eyebrow" style={{ justifyContent: 'center', marginBottom: 20 }}>Leadership</div>
            <h2 className="section-title">Board of <em>directors</em>.</h2>
            <p className="font-serif-i" style={{ color: 'var(--smoke)', maxWidth: 620, margin: '28px auto 0', fontSize: 17, lineHeight: 1.6 }}>
              Our leadership is driven by a shared vision of excellence, innovation, and long-term corporate customer success.
            </p>
          </div>
        </div>

        <div style={{ position: 'relative', paddingTop: 40 }}>
          <div style={{ position: 'absolute', top: 20, left: '5%', right: '5%', height: 2, background: 'linear-gradient(90deg, transparent, var(--brass), transparent)' }} />
          <div className="grid md:grid-cols-3 gap-10">
            {team.map((m, i) => <TeamCard key={m.name} m={m} i={i} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
